import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { urls } from 'Constants/Urls'
import { BankGuaranteeFull, DigitalLeadBg, LeadBg, PaperLeadBg } from 'Pages/ibro'
import { toFormData } from 'Helpers'

export const bgLeadApi = {
	agreePaperLead: async (id: number, data: PaperLeadBg) => {
		const res = await axiosDS().post<SimpleResponse>(
			urls.broker.paper_lead.replace(':id', id.toString()),
			toFormData(data)
		)
		return res.data
	},

	agreeDigitalLead: async (id: number, data: DigitalLeadBg) => {
		const res = await axiosDS().post<SimpleResponse>(
			urls.broker.digital_lead.replace(':id', id.toString()),
			toFormData(data)
		)
		return res.data
	},

	checkPersonalDataAgreement: async (id: number, inn: string) => {
		const res = await axiosDS().get<LeadBg>(
			`${urls.broker.bg_active.replace(':inn', inn)}?partner_id=${id}`
		)
		return res.data
	},

	changeLead: async (id: number, lead_id: number, requestOptions: {}) => {
		const res = await axiosDS().patch<BankGuaranteeFull>(
			urls.broker.change_lead.replace(':id', id.toString()),
			{
				data: { lead_id, ...requestOptions },
			}
		)
		return res.data
	},

	agreeConfirmation: async (id: number, phone: string, attorney?: boolean) => {
		const res = await axiosDS().patch<SimpleResponse>(
			urls.broker.confirmation.replace(':id', id.toString()),
			toFormData({ phone, attorney })
		)
		return res.data
	},
}
